import { render, staticRenderFns } from "./SummarizationSettings.vue?vue&type=template&id=06066db7"
import script from "./SummarizationSettings.vue?vue&type=script&lang=js"
export * from "./SummarizationSettings.vue?vue&type=script&lang=js"
import style0 from "./SummarizationSettings.vue?vue&type=style&index=0&id=06066db7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports